// Curated static treasures for the Ausstellungsraum (Brockenstube).
export const MARKETPLACE = {
  ricardo: "https://www.ricardo.ch/de/shop/Maras_Wunderkammer/offers/",
  tutti: "https://www.tutti.ch/de/seller?id=9066076472670068981",
  anibis: "https://www.anibis.ch/de/seller?id=3553809736251056186",
};

export const PLATFORM_LOGOS = {
  ricardo: "https://customer-assets.emergentagent.com/job_wunderkammer-basel/artifacts/5nytvi8l_Ricardo%20Logo%20.png",
  tutti: "https://customer-assets.emergentagent.com/job_wunderkammer-basel/artifacts/43si5pfl_images%20%282%29.png",
  anibis: "https://customer-assets.emergentagent.com/job_wunderkammer-basel/artifacts/vreehpi3_ANIBIS.png",
};

const ricardoSearch = () => "https://www.ricardo.ch/de/shop/Maras_Wunderkammer/offers/";
const tuttiSearch = () => "https://www.tutti.ch/de/seller?id=9066076472670068981";

export const treasures = [
  {
    id: "kaffeemuehle-antik",
    image: "https://images.unsplash.com/photo-1597668900045-b9283c0de174?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    era: "ca. 1920",
    price: "CHF 180",
    fresh: true,
    market: { platform: "ricardo", url: ricardoSearch("antike Kaffeemühle") },
    name: { de: "Antike Kaffeemühle", en: "Antique coffee grinder", it: "Macinacaffè antico", fr: "Moulin à café ancien", pt: "Moinho de café antigo" },
    tag: { de: "Sammlerstück", en: "Collectible", it: "Pezzo da collezione", fr: "Pièce de collection", pt: "Peça de coleção" },
  },
  {
    id: "kommode-nussbaum",
    image: "https://images.unsplash.com/photo-1715249891485-4b8e66b584dc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    era: "ca. 1890",
    price: "CHF 640",
    fresh: true,
    market: { platform: "tutti", url: tuttiSearch("Nussbaum Kommode antik") },
    name: { de: "Nussbaum-Kommode", en: "Walnut dresser", it: "Cassettiera in noce", fr: "Commode en noyer", pt: "Cómoda de nogueira" },
    tag: { de: "Möbel", en: "Furniture", it: "Mobili", fr: "Mobilier", pt: "Móvel" },
  },
  {
    id: "petroleum-lampe",
    image: "https://images.unsplash.com/photo-1688126753535-0ca32e3b5cbb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    era: "ca. 1910",
    price: "CHF 120",
    fresh: true,
    market: { platform: "ricardo", url: ricardoSearch("Petroleumlampe antik") },
    name: { de: "Petroleumlampe", en: "Petroleum lamp", it: "Lampada a petrolio", fr: "Lampe à pétrole", pt: "Candeeiro a petróleo" },
    tag: { de: "Beleuchtung", en: "Lighting", it: "Illuminazione", fr: "Éclairage", pt: "Iluminação" },
  },
  {
    id: "porzellan-service",
    image: "https://images.unsplash.com/photo-1560697043-f880bb028f1e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    era: "ca. 1930",
    price: "CHF 240",
    fresh: true,
    market: { platform: "tutti", url: tuttiSearch("Porzellan Service Vintage") },
    name: { de: "Porzellan-Service", en: "Porcelain set", it: "Servizio in porcellana", fr: "Service en porcelaine", pt: "Serviço de porcelana" },
    tag: { de: "Sammlerstück", en: "Collectible", it: "Pezzo da collezione", fr: "Pièce de collection", pt: "Peça de coleção" },
  },
  {
    id: "wandspiegel-gold",
    image: "https://images.unsplash.com/photo-1460776960860-7adc30a4e69d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    era: "ca. 1900",
    price: "CHF 380",
    market: { platform: "ricardo", url: ricardoSearch("vergoldeter Wandspiegel") },
    name: { de: "Vergoldeter Wandspiegel", en: "Gilded wall mirror", it: "Specchio dorato", fr: "Miroir mural doré", pt: "Espelho de parede dourado" },
    tag: { de: "Dekor", en: "Decor", it: "Decoro", fr: "Décor", pt: "Decoração" },
  },
  {
    id: "gemaelde-landschaft",
    image: "https://images.unsplash.com/photo-1652598631616-3f5f4d2cfbd5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    era: "ca. 1950",
    price: "CHF 290",
    market: { platform: "tutti", url: tuttiSearch("Landschaftsgemälde Vintage") },
    name: { de: "Landschaftsgemälde", en: "Landscape painting", it: "Dipinto di paesaggio", fr: "Peinture de paysage", pt: "Pintura de paisagem" },
    tag: { de: "Kunst", en: "Art", it: "Arte", fr: "Art", pt: "Arte" },
  },
];

export const freshTreasures = treasures.filter((t) => t.fresh).slice(0, 4);

export const cafeGallery = [
  "https://images.unsplash.com/photo-1731909997813-f3061fe69686?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "https://images.unsplash.com/photo-1645677020082-721a854c24f2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "https://images.unsplash.com/photo-1551887196-72e32bfc7bf3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
];

export const IMAGES = {
  heroAmbience: "https://images.unsplash.com/photo-1600093463592-8e36ae95ef56?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  cafeInterior: "https://images.unsplash.com/photo-1600093463592-8e36ae95ef56?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  cafeWarm: "https://images.unsplash.com/photo-1731909997813-f3061fe69686?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  brockenWide: "https://images.unsplash.com/photo-1571159346336-a29a1b400029?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  storyImage: "https://images.unsplash.com/photo-1662623646751-cfe9fb1a7309?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  servicesImage: "https://images.unsplash.com/photo-1560697043-f880bb028f1e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  logo: "https://customer-assets.emergentagent.com/job_wunderkammer-basel/artifacts/dkhdam91_Bildschirmfoto%202026-07-04%20um%2008.58.40.png",
};
